import { NextIntlClientProvider } from "next-intl";
import { useRouter } from "next/router";
import { PropsWithChildren } from "react";
import { useAuthenticatedUser } from "./hooks/useAuthenticatedUser";

export const TranslationsProvider = ({ children }: PropsWithChildren) => {
  const { userProfile } = useAuthenticatedUser();
  const { locale } = useRouter();
  const platformLanguage = userProfile?.language || locale;
  const timeZone = userProfile?.timezone || "Europe/Lisbon";
  //const messages = require(`@/translations/${platformLanguage}.json`);
  // explicit referencing files to see if improves performance
  const messages =
    platformLanguage === "en"
      ? require(`@/translations/en.json`)
      : require(`@/translations/pt.json`);
  return (
    <NextIntlClientProvider
      timeZone={timeZone}
      now={new Date()}
      messages={messages}
      locale={platformLanguage}
      /* onError={(error) => {
        throw error;
      }} */
      getMessageFallback={({ namespace, key }) => {
        throw new Error(
          `Missing translation for ${[namespace, key]
            .filter(Boolean)
            .join(".")}`
        );
      }}
    >
      {children}
    </NextIntlClientProvider>
  );
};
